(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-product-picker"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBundlePicker(sectionId) {
    var root         = document.getElementById('bundle-picker-' + sectionId);
    if (!root) return;

    var maxSel       = parseInt(root.dataset.maxSelections, 10) || 3;
    var cards        = root.querySelectorAll('.bpk-card');
    var itemsWrap    = root.querySelector('#bpk-items-' + sectionId);
    var emptyState   = root.querySelector('#bpk-empty-state-' + sectionId);
    var progressText = root.querySelector('#bpk-progress-text-' + sectionId);
    var barFill      = root.querySelector('#bpk-bar-' + sectionId);
    var checkoutBtn  = root.querySelector('#bpk-checkout-' + sectionId);
    var toast        = root.querySelector('#bpk-toast-' + sectionId);
    var toastTimer   = null;
    var storageKey   = 'bpk_selected_' + sectionId;

    var selected = [];

    var panel        = root.querySelector('#bpk-panel-' + sectionId);
    var toggleBtn    = root.querySelector('#bpk-panel-toggle-' + sectionId);
    var headerEl     = panel ? panel.querySelector('.bpk-panel-header') : null;

    if (panel && headerEl) {
      headerEl.addEventListener('click', function (e) {
        if (window.innerWidth <= 900) {
          var isExpanded = panel.classList.contains('is-expanded');
          panel.classList.toggle('is-expanded', !isExpanded);
          if (toggleBtn) {
            toggleBtn.setAttribute('aria-expanded', String(!isExpanded));
          }
        }
      });
    }

    // Collapse bottom sheet if user clicks outside of it on mobile
    document.addEventListener('click', function (e) {
      if (window.innerWidth <= 900) {
        if (!document.getElementById('bpk-panel-' + sectionId)) return;
        if (panel && panel.classList.contains('is-expanded') && !panel.contains(e.target)) {
          panel.classList.remove('is-expanded');
          if (toggleBtn) {
            toggleBtn.setAttribute('aria-expanded', 'false');
          }
        }
      }
    });

    function showToast() {
      if (!toast) return;
      toast.classList.add('is-visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 2400);
    }

    /* ── Save/Load selections from sessionStorage ── */
    function saveSelections() {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify(selected));
      } catch(e) {}
    }

    function loadSelections() {
      try {
        var saved = sessionStorage.getItem(storageKey);
        if (saved) {
          var parsed = JSON.parse(saved);
          if (Array.isArray(parsed)) {
            /* Validate that saved variant IDs still exist in current cards */
            var validIds = [];
            cards.forEach(function(c) { validIds.push(c.dataset.variantId); });
            parsed.forEach(function(item) {
              if (validIds.indexOf(item.variantId) > -1) {
                selected.push(item);
              }
            });
          }
        }
      } catch(e) {}
    }

    function renderPanel() {
      var rows = itemsWrap.querySelectorAll('.bpk-item-row');
      rows.forEach(function (r) { r.remove(); });

      if (selected.length === 0) {
        if (emptyState) emptyState.style.display = 'flex';
      } else {
        if (emptyState) emptyState.style.display = 'none';
        selected.forEach(function (item) {
          var row = document.createElement('div');
          row.className = 'bpk-item-row';
          row.dataset.variantId = item.variantId;
          row.innerHTML =
            '<img class="bpk-item-thumb" src="' + item.image + '" alt="' + item.title + '">' +
            '<div class="bpk-item-details">' +
              '<p class="bpk-item-name">' + item.title + '</p>' +
            '</div>' +
            '<button class="bpk-item-remove" aria-label="Remove ' + item.title + '" data-variant="' + item.variantId + '">' +
              '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/></svg>' +
            '</button>';

          row.querySelector('.bpk-item-remove').addEventListener('click', function (e) {
            e.stopPropagation();
            removeItem(item.variantId);
          });

          itemsWrap.appendChild(row);
        });
      }

      var pct = Math.min(Math.round((selected.length / maxSel) * 100), 100);
      if (barFill) barFill.style.width = pct + '%';

      var remaining = maxSel - selected.length;
      if (progressText) {
        if (remaining > 0) {
          progressText.innerHTML = "You're <strong>" + remaining + "</strong> item" + (remaining === 1 ? '' : 's') + " away from completing your Deluxe Sample Trio";
        } else {
          progressText.innerHTML = "✓ Your Deluxe Sample Trio is ready!";
        }
      }

      var complete = selected.length >= maxSel;
      if (checkoutBtn) {
        checkoutBtn.disabled = !complete;
        checkoutBtn.setAttribute('aria-disabled', String(!complete));
      }

      cards.forEach(function (card) {
        var btn = card.querySelector('.bpk-add-btn');
        if (!btn) return;
        var varId = card.dataset.variantId;
        var isAdded = selected.some(function (s) { return s.variantId === varId; });
        btn.classList.toggle('is-added', isAdded);
        var reachedMax = selected.length >= maxSel && !isAdded;
        btn.classList.toggle('is-disabled', reachedMax);
        btn.disabled = reachedMax;
        btn.querySelector('span').textContent = isAdded ? 'Remove' : 'Add to Cart';
      });

      saveSelections();
    }

    function addItem(card) {
      var variantId = card.dataset.variantId;
      if (selected.some(function (s) { return s.variantId === variantId; })) return;
      if (selected.length >= maxSel) { showToast(); return; }

      selected.push({
        variantId: variantId,
        productId: card.dataset.productId,
        title: card.dataset.productTitle,
        price: parseInt(card.dataset.productPrice, 10) || 0,
        image: card.dataset.productImage || ''
      });
      renderPanel();

      // Auto-expand on mobile when selection limit is reached
      if (selected.length >= maxSel && window.innerWidth <= 900 && panel) {
        panel.classList.add('is-expanded');
        if (toggleBtn) {
          toggleBtn.setAttribute('aria-expanded', 'true');
        }
      }
    }

    function removeItem(variantId) {
      selected = selected.filter(function (s) { return s.variantId !== variantId; });
      renderPanel();
    }

    cards.forEach(function (card) {
      var btn = card.querySelector('.bpk-add-btn');
      var imgLink = card.querySelector('.bpk-img-link');

      if (imgLink) {
        imgLink.addEventListener('click', function (e) { e.stopPropagation(); });
      }

      var titleLink = card.querySelector('.bpk-card-title');
      if (titleLink) {
        titleLink.addEventListener('click', function (e) { e.stopPropagation(); });
      }

      if (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          if (btn.classList.contains('is-disabled')) { showToast(); return; }
          
          var varId = card.dataset.variantId;
          var isAlreadyAdded = selected.some(function (s) { return s.variantId === varId; });
          if (isAlreadyAdded) {
            removeItem(varId);
          } else {
            addItem(card);
          }
        });
      }
    });

    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        if (selected.length < maxSel) return;

        checkoutBtn.classList.add('is-loading');
        checkoutBtn.disabled = true;

        var bundleVariantId = root.dataset.bundleVariantId;
        var payload;

        var cartItemsComponents = document.querySelectorAll('cart-items-component');
        var sectionIds = [];
        cartItemsComponents.forEach(function(item) {
          if (item.dataset.sectionId) {
            sectionIds.push(item.dataset.sectionId);
          }
        });

        if (sectionIds.length === 0) {
          sectionIds.push('cart-drawer');
        }

        if (bundleVariantId && bundleVariantId !== 'undefined' && bundleVariantId !== '') {
          var properties = {};
          selected.forEach(function (item, idx) {
            properties['Sample ' + (idx + 1)] = item.title;
          });
          payload = {
            items: [{
              id: parseInt(bundleVariantId, 10),
              quantity: 1,
              properties: properties
            }],
            sections: sectionIds.join(',')
          };
        } else {
          payload = {
            items: selected.map(function (item) {
              return { id: parseInt(item.variantId, 10), quantity: 1 };
            }),
            sections: sectionIds.join(',')
          };
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          checkoutBtn.classList.remove('is-loading');

          if (data.status && data.status !== 200) {
            console.error('Bundle ATC error:', data);
            checkoutBtn.disabled = false;
            return;
          }

          /* Clear selections after successful add */
          selected = [];
          saveSelections();
          renderPanel();

          /* ── Update cart count in header and trigger drawer morph ── */
          fetch('/cart.js', {
            headers: { 'Accept': 'application/json' }
          })
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            /* Update common cart count selectors */
            var countEls = document.querySelectorAll('.cart-count-bubble span, [data-cart-count], .cart-count, .header__cart-count, .js-cart-count, cart-count');
            countEls.forEach(function(el) {
              el.textContent = cart.item_count;
            });

            /* Dispatch events for theme cart updates */
            var cartUpdateEvent = new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: 'bundle-picker-' + sectionId,
                data: {
                  source: 'bundle-picker-custom',
                  itemCount: cart.item_count,
                  sections: data.sections
                }
              }
            });
            document.dispatchEvent(cartUpdateEvent);

            /* Try to open cart drawer */
            var drawerEl = document.querySelector('cart-drawer-component') ||
                           document.querySelector('cart-drawer') ||
                           document.querySelector('[data-cart-drawer]') ||
                           document.querySelector('.cart-drawer');

            if (drawerEl) {
              if (typeof drawerEl.open === 'function') {
                drawerEl.open();
              } else if (typeof drawerEl.showDialog === 'function') {
                drawerEl.showDialog();
              } else if (drawerEl.hasAttribute('open') !== undefined) {
                drawerEl.setAttribute('open', '');
                drawerEl.classList.add('is-open', 'active', 'drawer--is-open');
              }
            }
          })
          .catch(function() {});
        })
        .catch(function (err) {
          console.error('Bundle ATC fetch error:', err);
          checkoutBtn.classList.remove('is-loading');
          checkoutBtn.disabled = false;
        });
      });
    }

    /* Load saved selections & initial render */
    loadSelections();
    renderPanel();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.bpk-section[data-section-id]').forEach(function (el) {
      initBundlePicker(el.dataset.sectionId);
    });
  });

  document.addEventListener('shopify:section:load', function (e) {
    initBundlePicker(e.detail.sectionId);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-bottom-nav"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initMobileNav() {
    /* ══════════════════════════════════
       1. MENU → Theme's header drawer
    ══════════════════════════════════ */
    var menuBtn = document.getElementById('mob-nav-menu-btn');
    if (menuBtn) {
      menuBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var details = document.getElementById('Details-menu-drawer-container');
        if (!details) {
          var targets = [
            'header-drawer details',
            '.menu-drawer-container',
            '#Details-menu-drawer-container'
          ];
          for (var i = 0; i < targets.length; i++) {
            details = document.querySelector(targets[i]);
            if (details) break;
          }
        }

        if (details) {
          var headerDrawer = details.closest('header-drawer');
          var isOpen = details.hasAttribute('open');

          if (isOpen) {
            if (headerDrawer && typeof headerDrawer.close === 'function') {
              headerDrawer.close();
            } else {
              details.removeAttribute('open');
              details.classList.remove('menu-open');
            }
          } else {
            details.setAttribute('open', '');
            if (headerDrawer && typeof headerDrawer.open === 'function') {
              headerDrawer.open();
            } else {
              details.classList.add('menu-open');
            }
          }
        }
      });
    }

    /* ══════════════════════════════════
       2. CART → Theme's cart drawer
    ══════════════════════════════════ */
    var cartBtn = document.getElementById('mob-nav-cart-btn');
    if (cartBtn) {
      cartBtn.addEventListener('click', function () {
        var cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer) {
          if (typeof cartDrawer.open === 'function') { cartDrawer.open(); return; }
          if (typeof cartDrawer.showDialog === 'function') { cartDrawer.showDialog(); return; }
        }
        /* Fallback: click cart icon in header */
        var headerCartBtn = document.querySelector('.header-actions__action--cart, [data-cart-toggle], .cart-icon-button');
        if (headerCartBtn) { headerCartBtn.click(); return; }
        window.location.href = '/cart';
      });
    }

    /* ══════════════════════════════════
       3. SEARCH → Theme's search modal
       Theme: on:click="#search-modal/showDialog"
    ══════════════════════════════════ */
    var searchBtn = document.getElementById('mob-nav-search-btn');
    if (searchBtn) {
      searchBtn.addEventListener('click', function () {
        /* Click the header's search button — it handles all the dialog logic */
        var headerSearch = document.querySelector('search-button button');
        if (headerSearch) { headerSearch.click(); return; }

        /* Fallback: find dialog-component wrapping #search-modal and call showDialog */
        var searchDialog = document.getElementById('search-modal');
        if (searchDialog) {
          var dialogComp = searchDialog.closest('dialog-component');
          if (dialogComp && typeof dialogComp.showDialog === 'function') {
            dialogComp.showDialog();
            return;
          }
          /* Native dialog fallback */
          if (typeof searchDialog.showModal === 'function') searchDialog.showModal();
        }
      });
    }

    /* ══════════════════════════════════
       4. CART BADGE — live update
    ══════════════════════════════════ */
    document.addEventListener('cart:update', function (e) {
      var badge = document.getElementById('mob-nav-cart-count');
      if (!badge) return;
      var count = e.detail && e.detail.resource && e.detail.resource.item_count;
      if (count !== undefined) badge.textContent = count > 0 ? count : '';
    });

    /* ══════════════════════════════════
       5. WISHLIST BADGE — live update
    ══════════════════════════════════ */
    function updateWishlistBadge() {
      var badge = document.getElementById('mob-nav-wishlist-count');
      if (!badge) return;
      var count = 0;
      try {
        var raw = localStorage.getItem('astreabeauty_wishlist');
        if (raw) count = JSON.parse(raw).length;
      } catch (err) {}
      badge.textContent = count > 0 ? count : '';
    }
    updateWishlistBadge();
    document.addEventListener('wishlist:updated', updateWishlistBadge);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileNav);
  } else {
    initMobileNav();
  }

  document.addEventListener('shopify:section:load', initMobileNav);
})();

  } catch(e) { console.error(e); }
})();
})();
